



















import { Component, Vue } from 'vue-property-decorator';
import { stAuthenticationApi } from '@/services/st-api';
import StInput2 from '@/components/basic/StInput2.vue';
import { ForgotPasswordModel } from '@/services/api/nswag/stapiclient_generated';

@Component({
  components: {
    StInput2,
  },
})
export default class ForgotPassword extends Vue {
  requestSent = false;
  forgotPasswordModel: ForgotPasswordModel = new ForgotPasswordModel();
  loading: boolean = false;

  async submit() {
    this.loading = true;
    try {
      await stAuthenticationApi.forgotPassword(this.forgotPasswordModel);
      this.requestSent = true;
    } finally {
      this.loading = false;
    }
  }
}
